import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export function LandingFooter() {
  return (
    <footer data-testid="landing-footer" className="border-t border-white/10 py-10 px-6">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-5 text-sm text-zinc-500">
        {/* Top row */}
        <div className="flex flex-col sm:flex-row items-center justify-between w-full gap-4">
          <div className="flex items-center gap-2 text-white font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>
            <Sparkles size={16} className="text-[#00E5FF]" />
            Sera
          </div>
          <p>© {new Date().getFullYear()} Sera — un producto de EcommSystem. Todos los derechos reservados.</p>
          <Link to="/sign-in" data-testid="landing-footer-signin-link" className="hover:text-white transition-colors">
            ¿Ya eres cliente? Inicia sesión
          </Link>
        </div>
        {/* Legal links row */}
        <div className="flex items-center gap-6 text-xs text-zinc-600">
          <Link to="/legal" className="hover:text-zinc-400 transition-colors">Aviso Legal</Link>
          <span className="text-zinc-700">·</span>
          <Link to="/privacidad" className="hover:text-zinc-400 transition-colors">Política de Privacidad</Link>
          <span className="text-zinc-700">·</span>
          <Link to="/cookies" className="hover:text-zinc-400 transition-colors">Política de Cookies</Link>
          <span className="text-zinc-700">·</span>
          <a href="mailto:info@ecommsystem.net" className="hover:text-zinc-400 transition-colors">info@ecommsystem.net</a>
        </div>
      </div>
    </footer>
  );
}
